import { useSelector } from "react-redux";
import { isDomicilioAttivo } from "../../global/multiAsl";
import { ricercaIscrizioneSelector } from "../../modules/anagrafe/selectors";
import { Redirect } from "../tools/Redirect";
import { ROOT } from "../../global/urlMapping";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const DomicilioAttivoAsl = ({ children }) => {
    const navigate = useNavigate()
    const datiIscrizioneAsr = useSelector(ricercaIscrizioneSelector)?.value?.DatiMinimiIscrizione
    const aslAssistito = datiIscrizioneAsr?.CodiceAreaAssistenza ?? datiIscrizioneAsr?.CodiceAslAssistenza

    useEffect(() => {
        if (!isDomicilioAttivo(aslAssistito))
            navigate(ROOT)
    }, [aslAssistito, navigate])

    return (
        !isDomicilioAttivo(aslAssistito) ?
            < Redirect link={ROOT} /> :
            children
    );
};